import axios from "axios";

const apiUrl = "/etgs/api/common/date";

export const getOffsetDate = () => {
    return axios.get(apiUrl + "/offset");
}

export const updateOffsetDate = (offset) => {
    return axios.post(apiUrl + "/offset", {offset});
}

export const getLimitDates = () => {
    return axios.get(apiUrl + "/frontend-limits");
}